export const MAINTENANCE_STATUS_COLORS = {
  new: '#8000FF',
  requested: '#FFAA00',
  onNegotiation: '#29A329',
  done: '#2FB688',
  canceled: '#FF0000',
  reported: '#E51A80',
  pending: '#6699FF',
  scheduled: '#0055FF',
  inProgress: '#FF7733',
}

export const MAINTENANCE_STATUS_COLORS_OPACITY_10 = {
  new: 'rgba(128, 0, 255, 0.1)',
  requested: 'rgba(255, 170, 0, 0.1)',
  onNegotiation: 'rgba(41, 163, 41, 0.1)',
  done: 'rgba(47, 182, 136, 0.1)',
  canceled: 'rgba(255, 0, 0, 0.1)',
  reported: 'rgba(229, 26, 128, 0.1)',
  pending: 'rgba(102, 153, 255, 0.1)',
  scheduled: 'rgba(0, 85, 255, 0.1)',
  inProgress: 'rgba(255, 119, 51, 0.1)',
  archived: 'rgba(128, 128, 128, 0.1)',
}
